import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { FeatureStore } from '../stores/feature-store';

export const essayMarkingAccessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const nav = router.currentNavigation();

  if (!inject(AuthenticationService).isUserLoggedIn()) {
    return router.parseUrl('/login' + (nav?.finalUrl ? `?redirect=${nav.finalUrl.toString()}` : ''));
  }

  if (!inject(FeatureStore).isFeatureLive('essay-skills-feature')) {
    return router.parseUrl('/dashboard');
  }
  return true;
};
